export default {
    


    mutation_uivars_error_comboPerfilAgresor(state,valor){
        state.uivars_error_comboPerfilAgresor = valor;
    },

    mutation_uivars_verAsistenteNavegacion(state,valor){
        state.uivars_verAsistenteNavegacion = valor;
    },

mutation_uivars_verDocumentosAyuda(state,valor){
    state.uivars_verDocumentosAyuda = valor;
},

    mutation_uivars_menu(state,valor){
      state.uivars_menu = valor;
    },

    mutation_uivars_enDondeEstoy(state,valor){

          state.uivars_enDondeEstoy = valor;
    },

    mutation_uivars_overlay(state,valor){

        state.uivars_overlay= valor;

    },

    mutation_uivars_verComponenteVuePdfViewer(state,valor){
        state.verComponenteVuePdfViewer =valor;
    },

    
    mutation_uivars_vermenuprincipal(state,valor){

        state.uivars_vermenuprincipal= valor;

    },

    mutation_regresar_A_despues_de_impresion(state,valor){
        state.regresar_A_despues_de_impresion =valor;
    },

    mmutation_uivars_esincidente(state,valor){

        state.uivar_esincidente= valor;

    },

    mmutation_uivars_puedevermenulateral(state,valor){

        state.uivars_puedevermenulateral= valor;

    },
    mutation_uivars_puedever_configuracion(state,valor){
    state.uivars_puedever_configuracion = valor; },
    
    mmutation_uivars_hayUnUsuarioLogueado(state,valor){

        state.uivars_hayUnUsuarioLogueado= valor;

    },

    mutation_uivars_error_seleccionarPrograma(state,valor){

        state.uivars_error_seleccionarPrograma= valor;

    },
    mutation_uivars_error_seleccionarFecha(state,valor){

        state.uivars_error_seleccionarFecha= valor;
    },

    mutation_uivars_error_textAreaInvolucrados(state,valor){
        state.uivars_error_textAreaInvolucrados= valor;
    },

    mutation_uivars_error_textDenunciante(state,valor){
        state.uivars_error_textDenunciante= valor;
    },

    mutation_uivars_error_comboboxCargos(state,valor){

        state.uivars_error_comboboxCargos= valor;
    },

    mutation_uivars_error_textareaRegistros(state,valor) {

        state.uivars_error_textareaRegistros= valor;
    },

    mutation_uivars_error_comboPerfilvictima(state,valor) {

        state.uivars_error_comboPerfilvictima= valor;
    },

    mutation_uivars_error_comboRecibeAyuda(state,valor) {

        state.uivars_error_comboRecibeAyuda= valor;
    },

    mutation_uivars_error_textareaMedidas(state,valor){

        state.uivars_error_textareaMedidas= valor;

    },

    mutation_uivars_error_comboesunincidente( state,valor){

        state.uivars_error_comboesunincidente= valor;

    },

    mutation_uivars_error_textareaTestigos( state,valor){

        state.uivars_error_textareaTestigos= valor;

    },

    mutation_uivars_error_textareaValoracion(state,valor){

        state.uivars_error_textareaValoracion= valor;
    },
    
    mutation_uivars_error_cardConfirmacion(state,valor){

        state.uivars_error_cardConfirmacion= valor;
    },
    
    mutation_uivars_error_cardTipologia(state,valor){

        state.uivars_error_cardTipologia= valor;
    },

    mutation_uivars_error_cardNivelIncidente(state,valor){

        state.uivars_error_cardNivelIncidente = valor;
    },

    mutation_uivars_error_cardTipoCaso(state,valor){

        state.uivars_error_cardTipoCaso = valor;
    },
    
    mutation_uivars_error_cardTipoRespuesta(state,valor){

        state.uivars_error_cardTipoRespuesta = valor;
    },

    mutation_uivars_error_cardMedidasIntegrales(state,valor){

        state.uivars_error_cardMedidasIntegrales = valor;
    },
    
    mutation_uivars_docto_a_ver(state,valor){

        state.uivars_docto_a_ver = valor;
    },

    mutation_uivars_ir_origen_que_solicito_docto(state,valor){

        state.uivars_ir_origen_que_solicito_docto = valor;
    },

    mutation_uivars_tipo_conciencia_o_prevencion(state,valor){

        state.uivars_tipo_conciencia_o_prevencion = valor;
    },

    mutation_uivars_error_DocuementoConciencian(state,valor){

        state.uivars_error_DocuementoConciencia = valor;
    },
    

    //////conciencia ////////////
    mutation_uivars_error_conciencia_estatus(state,valor){

        state.uivars_error_conciencia_estatus = valor;
    },
    mutation_uivars_error_conciencia_clasificacion(state,valor){

        state.uivars_error_conciencia_clasificacion = valor;
    },
    mutation_uivars_conciencia_docto(state,valor){

        state.uivars_error_conciencia_docto = valor;
    },
    mutation_uivars_error_conciencia_estatusplan(state,valor){

        state.uivars_error_conciencia_estatusplan = valor;
    },

    ///////////////////////////////
    ///seguimiento////////////////

    mutation_uivars_error_seguimiento_seguimiento_id(state,valor){  
        
        state.uivars_error_seguimiento_seguimiento_id = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_incidenteid(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_incidenteid = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_status(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_status = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_plan(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_plan = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_documentos(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_documentos = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificaciondif(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificaciondif = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificacionautoridad(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificacionautoridad = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificacionpfn(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificacionpfn = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificaciodenunciante(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificaciodenunciante = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_actavaloracion(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_actavaloracion = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_planrecuperacion(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_planrecuperacion = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_plan_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_plan_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_documentos_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_documentos_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificaciondif_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificaciondif_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificacionautoridad_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificacionautoridad_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificacionpfn_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificacionpfn_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_notificaciodenunciante_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_notificaciodenunciante_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_actavaloracion_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_actavaloracion_docto = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_protocolosos(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_protocolosos = valor;  
        },
 mutation_uivars_error_seguimiento_seguimiento_planrecuperacion_docto(state,valor){  
         
        state.uivars_error_seguimiento_seguimiento_planrecuperacion_docto = valor;  
        },

        /////paramteors

        mutation_uivars_parametros(state,valor){  
         
            state.uivars_parametros = valor;  
            },

            mutation_uivars_imagenLogin(state,valor){  
         
            state.uivars_imagenLogin = valor;  
            
        },

        // cierer

        mutation_uivars_error_incidente_textocierre(state,valor){  
         
            state.uivars_error_incidente_textocierre = valor;  
            
        },

        mutation_uivars_cuantosTestigos(state,valor){  
         
            state.uivars_cuantosTestigos = valor;  
            
        },

  
}